export const elmoExperimentResourceNames = {
  default: 'GOPS_smarthelp',
  pcc: 'GOPS_smarthelp_pcc',
  stepUpVenice: 'GOPS_smarthelp_venice_step_up',
  kmSearch: 'GOPS_smarthelp_km_search',
};

export const elmoTreatmentNames = {
  kmSearchEnabled: 'Trmt_GOPS_Helpcenter_KM_Search_Enable',
};

export const isPartOfElmoExpTreatment = (elmoTreatments, treatmentName) => (Array.isArray(elmoTreatments) && elmoTreatments.indexOf(treatmentName) >= 0);
